import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: "25",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "#1D1A55",
    d: "M12.1 24.2c-1.7 0-3.2-.3-4.7-1-1.5-.6-2.8-1.5-3.8-2.6-1.1-1.1-2-2.4-2.6-3.8-.6-1.5-1-3-1-4.7s.3-3.2 1-4.7c.6-1.5 1.5-2.8 2.6-3.8C4.7 2.5 6 1.6 7.4 1c1.5-.6 3-1 4.7-1 1.3 0 2.6.2 3.7.6 1.2.4 2.3.9 3.3 1.6L17.3 4c-.8-.5-1.6-.9-2.5-1.1-.9-.3-1.8-.4-2.8-.4-2.7 0-5 .9-6.9 2.8s-2.8 4.2-2.8 6.9.9 5 2.8 6.9 4.2 2.8 6.9 2.8 5-.9 6.9-2.8 2.8-4.2 2.8-6.9c0-.4 0-.7-.1-1.1 0-.4-.1-.7-.2-1.1l2-2c.2.6.4 1.3.5 2s.2 1.4.2 2.1c0 1.7-.3 3.2-1 4.7-.6 1.5-1.5 2.8-2.6 3.8-1.1 1.1-2.4 2-3.8 2.6-1.4.7-2.9 1-4.6 1m-1.7-6.5-5.1-5.1L7 10.8l3.4 3.4L22.5 2.1l1.7 1.7z"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "#fff",
      d: "M0 0h24.2v24.2H0z"
    })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }